module.exports = __webpack_public_path__ + "static/media/huoyan.512d199.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/huoyan.mp3
// module id = EmWH
// module chunks = 208